import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { set } from 'lodash';
import genericSupplierClient from 'Services/Apis/Spot/genericSupplierClient';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

const initialState = {
  isVisibleDifal: false,
  isVisibleModalDifalTerms: false,
  createPDF: null,
  isLoadingPDF: false,
  isLoadingSpot: false,
  isErrorSpot: false,
  isReloadSpot: false,
  isValidToCheckout: true,
  quote: null,
  termUrl: null,
  dataSpot: {},
  productsPDF: null,
  loadingCategories: false,
  loadingSubCategories: false,
  dataCategories: [],
  dataSubCategories: [],
  errorCategories: false,
  errorSubCategories: false,
  loadingSubmitCategory: false,
};

export const loadDataSpot = createAsyncThunk(
  `spotAproveRedemption/loadDataSpot`,
  async (payload) => {
    const { data } = await redemptionsApiClient.get(`/Redemption/${payload.redemptionId}`, {
      headers: payload.headers,
    });

    return data;
  },
);

export const loadRedemptionCategories = createAsyncThunk(
  'spotNewSolicitationSlice/loadCategorias',
  async (_, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(`/Category`, {
      headers,
    });

    return data;
  },
);
export const loadRedemptionSubCategories = createAsyncThunk(
  'spotNewSolicitationSlice/loadSubCategorias',
  async ({ id }, { getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.get(`/Category/SubCategory?Categoryid=${id}`, {
      headers,
    });
    return data;
  },
);

export const updateCategories = createAsyncThunk(
  'spotAproveRedemption/updateCategories',
  async (payload, { dispatch, getState }) => {
    const { user } = getState().oidc;

    const headers = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const { data } = await redemptionsApiClient.put(`/Redemption/Category`, payload, {
      headers,
    });

    if (data) {
      dispatch(loadDataSpot({ redemptionId: payload.RedemptionId, headers }));
      dispatch(setReloadSpot(true));
    }

    return data;
  },
);

export const loadUserInfos = createAsyncThunk(
  'spotAproveRedemption/loadUserInfos',
  async (payload, { getState }) => {
    const { dataSpot } = getState().SpotAproveRedemption;

    const { data: dataUsername } = await redemptionsApiClient.get(
      `/Participant/${payload.participantId}`,
      {
        headers: payload.headers,
      },
    );

    const { data: dataBalance } = await redemptionsApiClient.get(
      `/Participant/balance?participantId=${payload.participantId}&username=${dataUsername.username}`,
      {
        headers: payload.headers,
      },
    );

    return {
      ...dataSpot,
      user: dataUsername,
      balance: dataBalance,
    };
  },
);

const spotAproveRedemption = createSlice({
  name: 'spotAproveRedemption',
  initialState: initialState,
  reducers: {
    setIsVisibleDifalModal(state, action) {
      state.isVisibleModalDifalTerms = action.payload;
    },
    setTermUrl(state, action) {
      state.termUrl = action.payload;
    },
    setIsValidToCheckout(state, action) {
      state.isValidToCheckout = action.payload;
    },
    setProductsPDF(state, action) {
      state.productsPDF = action.payload;
    },

    resetSubCategories(state) {
      state.dataSubCategories = [];
    },

    setReloadSpot(state, action) {
      state.isReloadSpot = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(loadUserInfos.pending, (state, action) => {
      state.isLoadingPDF = true;
    });

    builder.addCase(loadUserInfos.fulfilled, (state, action) => {
      state.createPDF = action.payload;
      state.isLoadingPDF = false;
    });
    builder.addCase(loadUserInfos.rejected, (state, action) => {
      console.log('loadUserInfos.rejected', action);
    });

    builder.addCase(loadDataSpot.pending, (state, action) => {
      state.isLoadingSpot = true;
      state.isErrorSpot = false;
    });
    builder.addCase(loadDataSpot.fulfilled, (state, action) => {
      state.dataSpot = action.payload;
      state.quote = action.payload?.files[0];
      state.isLoadingSpot = false;
      state.isReloadSpot = false;
    });
    builder.addCase(loadDataSpot.rejected, (state, action) => {
      console.log('loadDataSpot.rejected', action);
      state.isErrorSpot = true;
    });
    builder.addCase(loadRedemptionCategories.pending, (state) => {
      state.loadingCategories = true;
    });
    builder.addCase(loadRedemptionCategories.fulfilled, (state, action) => {
      state.loadingCategories = false;
      state.dataCategories = action.payload;
    });
    builder.addCase(loadRedemptionCategories.rejected, (state) => {
      state.loadingCategories = false;
      state.errorCategories = true;
    });
    builder.addCase(loadRedemptionSubCategories.pending, (state) => {
      state.loadingSubCategories = true;
    });
    builder.addCase(loadRedemptionSubCategories.fulfilled, (state, action) => {
      state.loadingSubCategories = false;
      state.dataSubCategories = action.payload;
    });
    builder.addCase(loadRedemptionSubCategories.rejected, (state) => {
      state.loadingSubCategories = false;

      state.errorSubCategories = true;
    });
    builder.addCase(updateCategories.pending, (state) => {
      state.loadingSubmitCategory = true;
    });
    builder.addCase(updateCategories.fulfilled, (state) => {
      state.loadingSubmitCategory = false;
    });
    builder.addCase(updateCategories.rejected, (state) => {
      state.loadingSubmitCategory = false;
    });
  },
});

export const {
  setIsVisibleDifalModal,
  setTermUrl,
  setIsValidToCheckout,
  setProductsPDF,
  resetSubCategories,
  setReloadSpot,
} = spotAproveRedemption.actions;
export default spotAproveRedemption.reducer;
